import convertObjectToFormData from "../utils/convertObjectToFormData";
import config from '../config';

export async function fetchProvidersList(page, itemsPerPage, qId, qName, branchFilter, token) { 
    const response = await fetch(`${config.API_URL}/admin/provider-list?page=${page}&itemsPerPage=${itemsPerPage}&q=${qId}&qname=${qName}&branchFilter=${branchFilter}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    return data;
}

export async function fetchActivityList(page, itemsPerPage, qId, qName, isWithImage, token) {
    const response = await fetch(`${config.API_URL}/activity-list?page=${page}&itemsPerPage=${itemsPerPage}&q=${qId}&qname=${qName}&isWithImage=${isWithImage}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    return data;
}


export async function fetchBranchList(page, itemsPerPage, qId, qName, token) {
    const response = await fetch(`${config.API_URL}/branch-list?page=${page}&itemsPerPage=${itemsPerPage}&q=${qId}&qname=${qName}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    })
    if (response.status !== 200) {
        throw Error('Failed to update');
    }
    const data = await response.json();
    return data;
}

export async function createProvider(providerInfo, token) {
    console.log(providerInfo);
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData(providerInfo)

    const res = await fetch(`${config.API_URL}/admin/provider`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    const body = res.json()

    if (res.status !== 200) {
        throw Error(body.errorMessage);
    }
    return body;
}


export async function sendWelcomeEmail(providerId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({providerId})

    const res = await fetch(`${config.API_URL}/admin/provider/send-welcome-email`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function sendActionEmail(providerId, branchId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({providerId, branchId})

    const res = await fetch(`${config.API_URL}/admin/provider/send-action-email`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to send actionEmail');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function toggleProviderVisibility(providerId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({providerId})

    const res = await fetch(`${config.API_URL}/admin/provider/toggle-visibility`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}

export async function deleteProviderAndUser(providerId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    const formData = convertObjectToFormData({providerId})

    const res = await fetch(`${config.API_URL}/admin/provider`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    console.log(body)
    return body;
}
